import { render } from "./Jazzicon.vue?vue&type=template&id=6e70e254"
import script from "./Jazzicon.vue?vue&type=script&lang=js"
export * from "./Jazzicon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__